import { render } from "./PageOrderDetail.vue?vue&type=template&id=918bba8e"
import script from "./PageOrderDetail.vue?vue&type=script&lang=js"
export * from "./PageOrderDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__